import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import * as firebase from 'firebase';
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../../environments/environment';
import cpfVerdadeiro from '../../funcoes/validar.cpf';

import { FuncionarioElement } from '../../interfaces/funcionario';
import telefoneVerdadeiro from '../../funcoes/validar.telefone';
@Component({
  selector: 'app-novo-funcionario',
  templateUrl: './novo-funcionario.component.html',
  styleUrls: ['./novo-funcionario.component.scss', '../../styles/estilo.padrao.scss']
})
export class NovoFuncionarioComponent implements OnInit {
  uid;
  funcionarioForm: FormGroup;
  inputTypePass = 'password';
  inputTypePass2 = 'password';
  iconeSenha = 'lock';
  iconeSenha2 = 'lock';
  bPermissaoCadastrar: Boolean = false; //Completar algoritmo para cadastro com permissão

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private af: AngularFireAuth
  ) {

    //Validar Permissões
    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.usuarioService.getFuncionario(this.uid).subscribe(dados => {
          if (dados) {
            const dadosFuncionario: any = dados;
            this.bPermissaoCadastrar = dadosFuncionario.Permissoes.Alterar.Clientes;
          }
        });
      } else
        this.bPermissaoCadastrar = true;
    });
  }

  //Máscaras
  maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  maskCPF = [/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/];

  ngOnInit(): void {
    this.funcionarioForm = this.formBuilder.group({
      email: ['', [Validators.email]],
      senha: ['', [Validators.required, Validators.min(8)]],
      nome: ['', [Validators.required]],
      telefone: ['', Validators.required],
      telefoneSecundario: ['', null],
      cpf: ['', [Validators.required, cpfVerdadeiro]],
      comissao: [1, [Validators.required, Validators.min(1)]],
      bTodosCadastro: [false, null],
      bTodosConsulta: [false, null],
      bTodosAlterar: [false, null],
      bTodosExcluir: [false, null],
      bTodosDemaisFuncoes: [false, null],
      //Cadastrar
      bRealizarCadastroClientes: [false, null],
      bRealizarCadastroFornecedores: [false, null],
      bRealizarCadastroFuncionarios: [false, null],
      bRealizarCadastroGrupos: [false, null],
      bRealizarCadastroProdutos: [false, null],
      //Consultar
      bRealizarConsultaClientes: [false, null],
      bRealizarConsultaFornecedores: [false, null],
      bRealizarConsultaFuncionarios: [false, null],
      bRealizarConsultaGrupos: [false, null],
      bRealizarConsultaProdutos: [false, null],
      bRealizarConsultaLogs: [false, null],
      //Alterar
      bAlterarClientes: [false, null],
      bAlterarFornecedores: [false, null],
      bAlterarFuncionarios: [false, null],
      bAlterarGrupos: [false, null],
      bAlterarProdutos: [false, null],
      //Excluir
      bExcluirVendas: [false, null],
      bExcluirProdutos: [false, null],
      //Demais Funções
      bVender: [true, null],
      bGerente: [false, null],
      senhaAdministrativa: ['', null],
    });

    this.funcionarioForm.get('bAlterarClientes').disable();
    this.funcionarioForm.get('bAlterarFornecedores').disable();
    this.funcionarioForm.get('bAlterarFuncionarios').disable();
    this.funcionarioForm.get('bAlterarGrupos').disable();
    this.funcionarioForm.get('bAlterarProdutos').disable();
    this.funcionarioForm.get('bExcluirProdutos').disable();
    this.funcionarioForm.get('comissao').disable();
  }

  async cadastrar() {
    this.spinner.show('default');
    console.log(this.funcionarioForm);
    if (this.funcionarioForm.valid) {
      const map: FuncionarioElement = {
        Status: true,
        Nome: this.f.nome.value.trim(),
        CPF: this.f.cpf.value.trim(),
        Telefone: this.f.telefone.value.trim(),
        TelefoneSecundario: this.f.telefoneSecundario.value.trim(),
        Email: this.f.email.value.trim(),
        Senha: this.f.senha.value.trim(),
        TimestampCadastro: firebase.default.database.ServerValue.TIMESTAMP,
        Comissao: 1,
        Permissoes: {
          Cadastrar: {
            Clientes: this.f.bRealizarCadastroClientes.value,
            Fornecedores: this.f.bRealizarCadastroFornecedores.value,
            Funcionarios: this.f.bRealizarCadastroFuncionarios.value,
            Grupos: this.f.bRealizarCadastroGrupos.value,
            Produtos: this.f.bRealizarCadastroProdutos.value,
          },
          Consultar: {
            Clientes: this.f.bRealizarConsultaClientes.value,
            Fornecedores: this.f.bRealizarConsultaFornecedores.value,
            Funcionarios: this.f.bRealizarConsultaFuncionarios.value,
            Grupos: this.f.bRealizarConsultaGrupos.value,
            Produtos: this.f.bRealizarConsultaProdutos.value,
            Logs: this.f.bRealizarConsultaLogs.value,
          },
          Alterar: {
            Clientes: this.f.bAlterarClientes.value,
            Fornecedores: this.f.bAlterarFornecedores.value,
            Funcionarios: this.f.bAlterarFuncionarios.value,
            Grupos: this.f.bAlterarGrupos.value,
            Produtos: this.f.bAlterarProdutos.value,
          },
          Excluir: {
            Vendas: this.f.bExcluirVendas.value,
            Produtos: this.f.bExcluirProdutos.value,
          },
          Vender: this.f.bVender.value,
          Gerente: this.f.bGerente.value,
        },
        SenhaAdministrativa: this.f.bGerente.value ? this.f.senhaAdministrativa.value : false,
      }

      try {
        const resp = await this.usuarioService.setFuncionario(map, this.uid);
        setTimeout(() => {
          if (resp.Status) {
            this.toastr.success(resp.Mensagem, 'Status', { progressBar: true, positionClass: 'toast-top-center', });
            setTimeout(() => {
              this.spinner.hide('default');

              this.usuarioService.setLog("Cadastro de novo funcionário: " + this.f.nome.value.trim() + '; ID: ' + resp.IDFuncionario, null, this.uid);

              this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/pages/consultar-funcionario"], { queryParams: { IDFuncionario: resp.IDFuncionario } }));
            }, 2000);
          } else {
            this.toastr.error('Erro: ' + resp.Mensagem, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });

            this.usuarioService.setLog("Erro no cadastro de novo funcionário: " + this.f.nome.value.trim() + '; Erro: ' + resp.Mensagem, null, this.uid);

            this.spinner.hide('default');
            // this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
            //   this.router.navigate(["/pages/novo-funcionario"]));
          }
        }, 1500);
      } catch (e) {
        console.log(e)
        this.spinner.hide('default');
        this.usuarioService.setLog("Erro no cadastro de novo funcionário: " + this.f.nome.value.trim() + '; Erro: ' + e, null, this.uid);

        this.toastr.error('Erro ao cadastrar funcionário!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/pages/novo-funcionario"]));
      }

    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.funcionarioForm.markAllAsTouched();
      setTimeout(() => this.spinner.hide('default'), 500);
    }
  }

  allCheck(s) {
    switch (s) {
      case 'Cadastrar':
        if (this.f.bTodosCadastro.value) {
          this.funcionarioForm.get('bRealizarCadastroClientes').patchValue(false);
          this.funcionarioForm.get('bRealizarCadastroFornecedores').patchValue(false);
          this.funcionarioForm.get('bRealizarCadastroFuncionarios').patchValue(false);
          this.funcionarioForm.get('bRealizarCadastroGrupos').patchValue(false);
          this.funcionarioForm.get('bRealizarCadastroProdutos').patchValue(false);
        } else {
          this.funcionarioForm.get('bRealizarCadastroClientes').patchValue(true);
          this.funcionarioForm.get('bRealizarCadastroFornecedores').patchValue(true);
          this.funcionarioForm.get('bRealizarCadastroFuncionarios').patchValue(true);
          this.funcionarioForm.get('bRealizarCadastroGrupos').patchValue(true);
          this.funcionarioForm.get('bRealizarCadastroProdutos').patchValue(true);
        }
        break;

      case 'Consultar':
        if (this.f.bTodosConsulta.value) {
          this.funcionarioForm.get('bRealizarConsultaClientes').patchValue(false);
          this.funcionarioForm.get('bRealizarConsultaFornecedores').patchValue(false);
          this.funcionarioForm.get('bRealizarConsultaFuncionarios').patchValue(false);
          this.funcionarioForm.get('bRealizarConsultaGrupos').patchValue(false);
          this.funcionarioForm.get('bRealizarConsultaProdutos').patchValue(false);
          this.funcionarioForm.get('bRealizarConsultaLogs').patchValue(false);
        } else {
          this.funcionarioForm.get('bRealizarConsultaClientes').patchValue(true);
          this.funcionarioForm.get('bRealizarConsultaFornecedores').patchValue(true);
          this.funcionarioForm.get('bRealizarConsultaFuncionarios').patchValue(true);
          this.funcionarioForm.get('bRealizarConsultaGrupos').patchValue(true);
          this.funcionarioForm.get('bRealizarConsultaProdutos').patchValue(true);
          this.funcionarioForm.get('bRealizarConsultaLogs').patchValue(true);
        }
        break;

      case 'Alterar':
        if (!this.f.bTodosAlterar.value) {
          if (this.f.bRealizarConsultaClientes.value) {
            this.funcionarioForm.get('bAlterarClientes').enable();
            this.funcionarioForm.get('bAlterarClientes').patchValue(true);
          }

          if (this.f.bRealizarConsultaFornecedores.value) {
            this.funcionarioForm.get('bAlterarFornecedores').enable();
            this.funcionarioForm.get('bAlterarFornecedores').patchValue(true);
          }

          if (this.f.bRealizarConsultaFuncionarios.value) {
            this.funcionarioForm.get('bAlterarFuncionarios').enable();
            this.funcionarioForm.get('bAlterarFuncionarios').patchValue(true);
          }

          if (this.f.bRealizarConsultaGrupos.value) {
            this.funcionarioForm.get('bAlterarGrupos').enable();
            this.funcionarioForm.get('bAlterarGrupos').patchValue(true);
          }

          if (this.f.bRealizarConsultaProdutos.value) {
            this.funcionarioForm.get('bAlterarProdutos').enable();
            this.funcionarioForm.get('bAlterarProdutos').patchValue(true);

            this.funcionarioForm.get('bExcluirProdutos').enable();
          }
        } else {
          this.funcionarioForm.get('bAlterarClientes').patchValue(false);
          this.funcionarioForm.get('bAlterarFornecedores').patchValue(false);
          this.funcionarioForm.get('bAlterarFuncionarios').patchValue(false);
          this.funcionarioForm.get('bAlterarGrupos').patchValue(false);
          this.funcionarioForm.get('bAlterarProdutos').patchValue(false);
          this.funcionarioForm.get('bExcluirProdutos').disable();
          this.funcionarioForm.get('bExcluirProdutos').patchValue(false);
        }
        break;

      case 'Excluir':
        if (!this.f.bTodosExcluir.value) {
          this.funcionarioForm.get('bExcluirVendas').patchValue(true);
          if (this.f.bAlterarProdutos.value) {
            this.funcionarioForm.get('bExcluirProdutos').enable();
            this.funcionarioForm.get('bExcluirProdutos').patchValue(true);
          }
        } else {
          this.funcionarioForm.get('bExcluirVendas').patchValue(false);
          this.funcionarioForm.get('bExcluirProdutos').patchValue(false);
        }
        break;

      case 'DemaisFuncoes':
        if (!this.f.bTodosDemaisFuncoes.value) {
          this.funcionarioForm.get('bVender').patchValue(true);
          this.funcionarioForm.get('bGerente').patchValue(true);
          this.funcionarioForm.get('senhaAdministrativa').setValidators([Validators.required, Validators.min(8)]);
        } else {
          this.funcionarioForm.get('bVender').patchValue(false);
          this.funcionarioForm.get('bGerente').patchValue(false);

          this.funcionarioForm.get('senhaAdministrativa').clearValidators();
          this.funcionarioForm.get('senhaAdministrativa').updateValueAndValidity()
        }
        break;
    }
  }

  checkAlterado() {
    if (this.f.bRealizarConsultaClientes.value) {
      this.funcionarioForm.get('bAlterarClientes').enable();
    } else {
      this.funcionarioForm.get('bAlterarClientes').disable();
      this.funcionarioForm.get('bAlterarClientes').patchValue(false);
    }

    if (this.f.bRealizarConsultaFornecedores.value) {
      this.funcionarioForm.get('bAlterarFornecedores').enable();
    } else {
      this.funcionarioForm.get('bAlterarFornecedores').disable();
      this.funcionarioForm.get('bAlterarFornecedores').patchValue(false);
    }

    if (this.f.bRealizarConsultaFuncionarios.value) {
      this.funcionarioForm.get('bAlterarFuncionarios').enable();
    } else {
      this.funcionarioForm.get('bAlterarFuncionarios').disable();
      this.funcionarioForm.get('bAlterarFuncionarios').patchValue(false);
    }

    if (this.f.bRealizarConsultaGrupos.value) {
      this.funcionarioForm.get('bAlterarGrupos').enable();
    } else {
      this.funcionarioForm.get('bAlterarGrupos').disable();
      this.funcionarioForm.get('bAlterarGrupos').patchValue(false);
    }

    if (this.f.bRealizarConsultaProdutos.value) {
      this.funcionarioForm.get('bAlterarProdutos').enable();
    } else {
      this.funcionarioForm.get('bAlterarProdutos').disable();
      this.funcionarioForm.get('bAlterarProdutos').patchValue(false);
    }

    if (this.f.bAlterarProdutos.value) {
      this.funcionarioForm.get('bExcluirProdutos').enable();
    } else {
      this.funcionarioForm.get('bExcluirProdutos').disable();
      this.funcionarioForm.get('bExcluirProdutos').patchValue(false);
    }

    if (this.f.bGerente.value) {
      this.funcionarioForm.get('senhaAdministrativa').setValidators([Validators.required, Validators.min(8)]);
    } else {
      this.funcionarioForm.get('senhaAdministrativa').clearValidators();
      this.funcionarioForm.get('senhaAdministrativa').updateValueAndValidity();
    }
  }

  exibirSenha(b) {
    if (b) {
      this.inputTypePass = this.inputTypePass === 'password' ? 'text' : 'password';
      this.iconeSenha = this.iconeSenha === 'lock' ? 'lock_open' : 'lock';
    } else {
      this.inputTypePass2 = this.inputTypePass2 === 'password' ? 'text' : 'password';
      this.iconeSenha = this.iconeSenha === 'lock' ? 'lock_open' : 'lock';
    }
  }

  limparCampos() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/novo-funcionario"]));
  }

  onChangeTel(e, b) {
    if (e.length >= 6) {
      if (e.substring(5, 6) === '9') {
        b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', '9', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', '9', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      } else {
        b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
    } else {
      b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.funcionarioForm.controls; }

}
